(function (root, factory) {
    root.immslidertools = new factory(jQuery);
})(this, function ($) {
    var Self = this;

    Self.old = [],
        Self.ord = [],
        Self.beforeChange = [],
        Self.afterChange = [],
        Self.windowFunc = function () {
            $(window).load(function () {
                Self.arrayManager(Self.old);
            });
            $(window).resize(function () {
                Self.arrayManager(Self.ord);
            });
        },
        Self.arrayManager = function (array) {
            if (array.length > 0) {
                var args = arguments;
                $.each(array, function (index, value) {
                    value([].slice.call(args, 1));
                });
            }
        },
        Self.screenInit = function (opt, elm) {
            elm.css({
                'height': ''
            });
            // var option = $.parseJSON(opt),
            var option = opt,
                w = 0,
                h = 0,
                ww = $(window).width(),
                wh = $(window).height();
            if (ww < 991) {
                wh = option.fullscreenoptionMob != '' && $('' + option.fullscreenoptionMob + '').length > 0 && $('' + option.fullscreenoptionMob + '').height() < wh ? wh - $('' + option.fullscreenoptionMob + '').height() : wh;
                if (option.fullscreenMob === 'true' || option.fullscreenMob === true) {
                    if (option.forceFullscreenMob === 'true' || option.forceFullscreenMob === true) {
                        var offsetLeft = (typeof option.offsetLeftByQueryMob !== 'undefined' && $(option.offsetLeftByQueryMob).length > 0 ? $(option.offsetLeftByQueryMob).offset().left : (typeof option.offsetLeftMob !== 'undefined' ? option.offsetLeftMob : 0));
                        w = (offsetLeft !== 0 ? ww - offsetLeft : ww), h = (wh < ww) ? ww : wh, elm.offset({
                            left: offsetLeft
                        }), elm.width(w), elm.find('.immSlider-slide').height(h);
                    } else {
                        elm.css({
                            'width': '',
                            'left': ''
                        }), w = elm.width(), h = (w * 60) / 100, elm.find('.immSlider-slide').height(h);
                    }
                    if (option.sliderHeightMob > 0) {
                        if (option.sliderHeight_prefixMob == 'percentviewport') {
                            h = (wh * option.sliderHeightMob) / 100;
                            elm.find('.immSlider-slide').height(h)
                        } else if (option.sliderHeight_prefixMob == 'percentwidth') {
                            h = (elm.width() * option.sliderHeightMob) / 100;
                            elm.find('.immSlider-slide').height(h);
                        } else if (option.sliderHeight_prefixMob == 'percentparent') {
                            p = elm.parent();
                            h = (p.height() * option.sliderHeightMob) / 100;
                            elm.find('.immSlider-slide').height(h);
                        } else {
                            h = option.sliderHeightMob;
                            elm.find('.immSlider-slide').css({
                                'height': h + 'px'
                            });
                        }
                    }
                } else {
                    if (option.sliderWidth_prefixMob == 'percentviewport') {
                        w = (ww * option.sliderWidthMob) / 100;
                        elm.width(w);
                    } else if (option.sliderWidth_prefixMob == 'percentparent') {
                        p = elm.parent();
                        w = (p.width() * option.sliderWidthMob) / 100;
                        elm.width(w);
                    } else {
                        w = option.sliderWidthMob
                        elm.css({
                            'width': w + 'px'
                        });
                    }
                    if (option.sliderHeight_prefixMob == 'percentviewport') {
                        h = (wh * option.sliderHeightMob) / 100;
                        elm.find('.immSlider-slide').height(h)
                    } else if (option.sliderHeight_prefixMob == 'percentwidth') {
                        h = (elm.width() * option.sliderHeightMob) / 100;
                        elm.find('.immSlider-slide').height(h);
                    } else if (option.sliderHeight_prefixMob == 'percentparent') {
                        p = elm.parent();
                        h = (p.height() * option.sliderHeightMob) / 100;
                        elm.find('.immSlider-slide').height(h);
                    } else {
                        h = option.sliderHeightMob;
                        elm.find('.immSlider-slide').css({
                            'height': h + 'px'
                        });
                    }
                }
                if (option.sliderWidthFixerEnableMob === 'true' || option.sliderWidthFixerEnableMob === true) {
                    var fixerValue = (option.sliderWidthFixer_prefixMob == 'pixel' ? option.sliderWidthFixerMob : ((w * option.sliderWidthFixerMob) / 100));
                    w = option.sliderWidthFixer_modeMob == 'increase' ? w + fixerValue : w - fixerValue;
                    elm.width(w);
                }
                if (option.sliderHeightFixerEnableMob === 'true' || option.sliderHeightFixerEnableMob === true) {
                    var fixerValue = (option.sliderHeightFixer_prefixMob == 'pixel' ? option.sliderHeightFixerMob : ((h * option.sliderHeightFixerMob) / 100));
                    h = option.sliderHeightFixer_modeMob == 'increase' ? h + fixerValue : h - fixerValue;
                    elm.find('.immSlider-slide').height(h);
                }
            } else {
                wh = option.fullscreenoption != '' && $('' + option.fullscreenoption + '').length > 0 && $('' + option.fullscreenoption + '').height() < wh ? wh - $('' + option.fullscreenoption + '').height() : wh;
                if (option.fullscreen === 'true' || option.fullscreen === true) {
                    if (option.forceFullscreen === 'true' || option.forceFullscreen === true) {
                        var offsetLeft = (typeof option.offsetLeftByQuery !== 'undefined' && $(option.offsetLeftByQuery).length > 0 ? $(option.offsetLeftByQuery).offset().left : (typeof option.offsetLeft !== 'undefined' ? option.offsetLeft : 0));
                        w = (offsetLeft !== 0 ? ww - offsetLeft : ww), h = wh, elm.offset({
                            left: offsetLeft
                        }), elm.width(w), elm.find('.immSlider-slide').height(h);
                    } else {
                        elm.css({
                            'width': '',
                            'left': ''
                        }), w = elm.width(), h = (w * 60) / 100, elm.find('.immSlider-slide').height(h);
                    }
                    if (option.sliderHeight > 0) {
                        if (option.sliderHeight_prefix == 'percentviewport') {
                            h = (wh * option.sliderHeight) / 100;
                            elm.find('.immSlider-slide').height(h)
                        } else if (option.sliderHeight_prefix == 'percentwidth') {
                            h = (elm.width() * option.sliderHeight) / 100;
                            elm.find('.immSlider-slide').height(h);
                        } else if (option.sliderHeight_prefix == 'percentparent') {
                            p = elm.parent();
                            h = (p.height() * option.sliderHeight) / 100;
                            elm.find('.immSlider-slide').height(h);
                        } else {
                            h = option.sliderHeight;
                            elm.find('.immSlider-slide').css({
                                'height': h + 'px'
                            });
                        }
                    }
                } else {
                    if (option.sliderWidth_prefix == 'percentviewport') {
                        w = (ww * option.sliderWidth) / 100;
                        elm.width(w);
                    } else if (option.sliderWidth_prefix == 'percentparent') {
                        p = elm.parent();
                        w = (p.width() * option.sliderWidth) / 100;
                        elm.width(w);
                    } else {
                        w = option.sliderWidth;
                        elm.css({
                            'width': w + 'px'
                        });
                    }
                    if (option.sliderHeight_prefix == 'percentviewport') {
                        h = (wh * option.sliderHeight) / 100;
                        elm.find('.immSlider-slide').height(h)
                    } else if (option.sliderHeight_prefix == 'percentwidth') {
                        h = (elm.width() * option.sliderHeight) / 100;
                        elm.find('.immSlider-slide').height(h);
                    } else if (option.sliderHeight_prefix == 'percentparent') {
                        p = elm.parent();
                        h = (p.height() * option.sliderHeight) / 100;
                        elm.find('.immSlider-slide').height(h);
                    } else {
                        h = option.sliderHeight;
                        elm.find('.immSlider-slide').css({
                            'height': h + 'px'
                        });
                    }

                }
                if (option.sliderWidthFixerEnable === 'true' || option.sliderWidthFixerEnable === true) {
                    var fixerValue = (option.sliderWidthFixer_prefix == 'pixel' ? option.sliderWidthFixer : ((w * option.sliderWidthFixer) / 100));
                    w = option.sliderWidthFixer_mode == 'increase' ? w + fixerValue : w - fixerValue;
                    elm.width(w);
                }
                if (option.sliderHeightFixerEnable === 'true' || option.sliderHeightFixerEnable === true) {
                    var fixerValue = (option.sliderHeightFixer_prefix == 'pixel' ? option.sliderHeightFixer : ((h * option.sliderHeightFixer) / 100));
                    h = option.sliderHeightFixer_mode == 'increase' ? h + fixerValue : h - fixerValue;
                    elm.find('.immSlider-slide').height(h);
                }
            }
        };

});
(function (root, factory) {
    var tools = typeof root.immslidertools !== 'undefined' ? root.immslidertools : false,
        breakpoint = typeof root.immsliderbreakpoint !== 'undefined' ? root.immsliderbreakpoint : false,
        progressbar = typeof root.immsliderProgressBar !== 'undefined' ? root.immsliderProgressBar : false;

    document.addEventListener('DOMContentLoaded', function () {
        root.immslider = new factory(jQuery, tools, breakpoint, progressbar);
        root.immslider.init(jQuery('.imm-slider-section[data-slider-id]'));
    });
})(this, function ($, tools, breakpoint, progressbar) {
    var Self = this,
        Tools = tools,
        Breakpoint = breakpoint,
        ProgressBar = progressbar;

    Self.sliderelm = {},
        Self.slideropt = {},
        Self.wt = {};

    Self.init = function (elm) {
        // Declare tools
        if (Breakpoint) {
            Breakpoint.init(Self);
        }
        // Declare tools

        elm.each(function () {
            var slider_id = $(this).data('slider-id'),
                config = immSliderData[slider_id].slider_option;
            Self.sliderelm[slider_id] = $('#' + slider_id);
            Self.wt[slider_id] = 0;
            // Self.slideropt[slider_id] = JSON.stringify(config);
        }).promise().done(function () {
            $.each(Self.sliderelm, function (i, elm) {
                // var option = $.parseJSON(immSliderData[i].slider_option);
                var option = immSliderData[i].slider_option;
                console.time('JS Performance Test immSlider (' + elm.attr('id') + ')');
                if (option.breakpointSlider == 'true') {
                    Breakpoint.breakpointProcces(immSliderData[i].slider_option, elm);
                    Breakpoint.checkBreakpoint(immSliderData[i].slider_option, elm);
                }
                Self.events(immSliderData[i].slider_option, elm);
                elm.find('.immSlider-initialize-place').remove();
                window.onpopstate = function () {
                    Tools.screenInit(immSliderData[i].slider_option, elm);
                    if (elm.hasClass('slick-initialized')) {
                        elm.slick('slickGoTo', 0);
                    }
                };
                Tools.screenInit(immSliderData[i].slider_option, elm);
                Self.initial(immSliderData[i].slider_option, elm);
                console.timeEnd('JS Performance Test immSlider (' + elm.attr('id') + ')');
            });
        });

        Tools.windowFunc();
    };

    Self.initial = function (opt, elm) {
        // var option = $.parseJSON(opt);
        var option = opt;
        elm.slick({
            accessibility: true,
            adaptiveHeight: false,
            appendArrows: elm.find('.immSlider-nav'),
            appendDots: elm.find('.immSlider-page'),
            arrows: (option.directionNav === 'true'),
            asNavFor: null,
            prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">' + option.prevText + '</button>',
            nextArrow: '<button class="slick-next" aria-label="Next" type="button">' + option.nextText + '</button>',
            autoplay: (option.sliderProgress === 'true') ? false : (option.slideshow === 'true'),
            autoplaySpeed: option.slideshowSpeed,
            centerMode: false,
            centerPadding: '0px',
            cssEase: 'ease',
            customPaging: function (slider, i) {
                return $('<button type="button" />').text(i + 1);
            },
            dots: (option.controlNav === 'true'),
            dotsClass: 'slick-dots',
            draggable: (option.draggable === 'true'),
            easing: 'linear',
            edgeFriction: 0.35,
            fade: (option.animation !== 'slide') ? true : false,
            focusOnSelect: false,
            focusOnChange: false,
            infinite: (option.sliderLoop === 'true'),
            initialSlide: 0,
            lazyLoad: '',
            mobileFirst: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            pauseOnDotsHover: false,
            respondTo: 'window',
            responsive: null,
            rows: 1,
            rtl: false,
            slide: '.immSlider-slide',
            slidesPerRow: 1,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: option.animationSpeed,
            swipe: true,
            swipeToSlide: false,
            touchMove: true,
            touchThreshold: 5,
            useCSS: true,
            useTransform: true,
            variableWidth: false,
            vertical: (option.verticalSlide === 'true'),
            verticalSwiping: (option.verticalSwipe === 'true' || option.swipeverticalnavigation === 'true'),
            waitForAnimate: true,
            zIndex: 1000
        });
    };

    Self.events = function (v, n) {
        // var o = $.parseJSON(v);
        var o = v;
        var interVal = '';
        n.on('init', function (event, slick, currentSlide) {

        });
        if (o.mousescrollnavigation == 'true') {
            n.on('wheel', (function (e) {
                e.preventDefault();

                if (e.originalEvent.deltaY < 0) {
                    $(this).slick('slickPrev');
                } else {
                    $(this).slick('slickNext');
                }
            }));
        }
        n.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            Tools.arrayManager(Tools.beforeChange, slick, currentSlide, nextSlide);
        });
        n.on('afterChange', function (event, slick, currentSlide) {
            Tools.arrayManager(Tools.afterChange, slick, currentSlide);
        });
        n.on('init', function (event, slick) {
            n.css({
                'height': ''
            });
            Tools.screenInit(v, n);
            slick.setPosition();
            if (o.sliderProgress == 'true' && ProgressBar) {
                ProgressBar.init(v, n);
            }
            Tools.old.push(function () {
                Tools.screenInit(v, n);
                slick.setPosition();
                if (n.hasClass('slick-initialized')) {
                    n.slick('slickGoTo', 0);
                }
            });
            Tools.ord.push(function () {
                if (o.breakpointSlider == 'true') {
                    Breakpoint.checkBreakpoint(v, n);
                }
                Tools.screenInit(v, n);
                slick.setPosition();
            });
            if (typeof Pace !== 'undefined') {
                Pace.on('done', function () {
                    $(window).trigger('resize');
                    if (n.hasClass('slick-initialized')) {
                        n.slick('slickGoTo', 0);
                    }
                });
            }
        });
        n.on('setPosition', function (event, slick) {

        });
        if ($(window).width() < 991) {
            n.on('touchstart touchend touchcancel touchmove', function () {
                $(this).slick('slickPlay');
            });
        }
    };
});